import { supabase } from "@/integrations/supabase/client";

export interface ScreenplayDeletion {
  deleted: boolean;
  cleanup_complete: boolean;
  pending_files: number;
  deleted_files: number;
  shared_files: number;
}

export async function deleteScreenplay(id: string, action: "delete" | "status" = "delete"): Promise<ScreenplayDeletion> {
  const { data, error } = await supabase.auth.getSession();
  if (error || !data.session?.access_token) throw new Error("Sign in to manage screenplays.");
  const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/screenplay-delete`, {
    method: "POST", headers: { Authorization: `Bearer ${data.session.access_token}`,
      apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY, "Content-Type": "application/json" },
    body: JSON.stringify({ screenplay_id: id, action, confirm_audio_deletion: action === "delete" }),
    signal: AbortSignal.timeout(90000),
  });
  const result = await response.json();
  if (!response.ok || result.deleted !== true) throw new Error(result.error || "Deletion could not be confirmed. Please retry.");
  return result;
}

export async function renameScreenplay(userId: string, id: string, name: string): Promise<string> {
  const title = name.trim();
  if (!title || title.length > 200) throw new Error("Enter a screenplay name between 1 and 200 characters.");
  const { data, error } = await supabase.from("screenplays")
    .update({ title, original_filename: title }).eq("id", id).eq("user_id", userId).select("id").single();
  if (error || data?.id !== id) throw new Error("The screenplay could not be renamed. Please retry.");
  return title;
}
